<template>
    <div class="mt20 recAgency tabs" id="recommendedOrgan">
        <div class="tabsCon" style="display:block;"  v-if="brandList!=null">
            <ul class="brand-list-box">
                 <template v-for="(m,k) in brandList" >
                   <li :style="k>5&&brandList.length==13?'width: calc((100% - 84px) / 7);margin-right: 10px;':''" :key="k">
                        <a :href="m.link" target="_blank" class="brand-link">
                            <img :alt="m.name" :src="m.logo_pic">
                        </a>
                    </li>
                </template>
              
            </ul>
        </div>
        <!-- <div class="bdtit z">
            <h2 class="titName">品牌专区</h2>
            <ul class="tabsTag nobgTab TopTabs" v-if="brandClass.length">
                <template v-for="(item,i) in brandClass">
                    <li :key="i" @mouseenter="hoverBrand(item,$event)" :class="{'curr':i==0}"><a href="javascript:;">{{item.name}}</a></li>
                </template>
            </ul>
        </div>
        
        <div class="BotTabs" v-if="brandArea.length">
            <ul class="tabsTag nobgTab">
                <template v-for="(item,i) in brandArea">
                    <li class="" :key="i" @mouseenter="hoverBrand(item,$event)"><a href="javascript:;">{{item.name}}</a></li>
                </template>
            </ul>
        </div> -->
    </div>
</template>

<script>
import $ from 'jquery'
export default {
    name: "brandArea",
    props:{
        brandArea:{
            type:Array
        },
        brandClass:{
            type:Array
        }
    },
    data(){
        return{
            brandList:[]
        }
    },
    watch:{
        brandClass(){
            if(this.brandClass && this.brandClass.length > 0){
                this.brandList = this.brandClass[0].organ_list
            }
        }
    },
    mounted() {
    },
    methods:{
        hoverBrand(item,e){
            let $target = $(e.target)
            let obj = $target.closest('li');
            let oBox = $target.closest('#recommendedOrgan')
            oBox.find('.tabsTag li').removeClass('curr')
            obj.addClass('curr')
            this.brandList = item.organ_list || []
        }
    }
}
</script>

<style scoped lang="scss">
.recAgency{width:980px;margin:0 auto;}
.recAgency{width:994px; margin:0 auto;}
.recAgency .bdtit{margin:0px 7px; }
.recAgency .bdtit .titName{ float:left;}
.recAgency .nobgTab{ padding-left:3px;}
.recAgency .nobgTab li{ border-left:1px solid #ccc; border-right:0px; cursor:pointer}
.recAgency .nobgTab .first{ border-left:none;}
.recAgency .tabs{background:url(../../../assets/imgs/old/dashed.png) 0px 100% repeat-x; }
.recAgency .BotTabs{background:url(../../../assets/imgs/old/dashed.png) 0px 0px repeat-x; padding-top: 1px;margin:0px 4px;}
.recAgency .BotTabs ul{ text-align: center;background:url(../../../assets/imgs/old/bg.png) 0px 0px repeat; padding:3px 0px 5px;*padding:13px 0px; overflow: hidden;}
.recAgency .BotTabs li{ display: inline-block;*display:inline;*zoom:1; float: none; }

.nobgTab a:hover, .nobgTab .curr a {
    color: #FEFEFE;
    background: #0F820C;
}

.nobgTab a {
    color: #666666;
    letter-spacing: 1px;
}
.nobgTab .first {
    padding-left: 10px;
}

.nobgTab li {
    border-right: 1px solid #CCCCCC;
    padding: 0 19px 0 20px;
    line-height: 1;
    text-align: center;
    font-weight: bold;
    font-size: 14px;
}
// .recAgency .tabsCon{ padding:10px 0px;*zoom:1;}

.brand-list-box {
    display: flex;
    flex-wrap: wrap;
    margin: 0 -7px 0 7px;
    justify-content: flex-start;
}
.brand-list-box li {
    width: calc((100% - 84px) / 6);
    height: 87px;
    margin-right: 14px;
    margin-bottom: 14px;
    background: #fff;
    border: 1px solid #eee;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s;
    border-radius: 3px;
}
.brand-list-box li:hover {
    box-shadow: 0 0 10px rgba(0,0,0,0.1);
}
.brand-link {
    display: block;
    width: 100%;
    height: 100%;
    padding: 0;
    box-sizing: border-box;
    overflow: hidden;
}
.brand-link img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    border-radius: 3px;
}
</style>
